import type React from "react";

import { Progress as ShadcnProgress } from "src/shadcn/components/progress";

const Progress = (props: React.ComponentProps<typeof ShadcnProgress>) => (
  <ShadcnProgress {...props} />
);

export { Progress };
